module.exports = __webpack_public_path__ + "img/pop_img.e2875cf5.png";